import { useMutation, useQueryClient } from '@tanstack/react-query';
import productEditUseCase from '../factories/productEdit';
import {
  REACT_QUERY_GET_PRODUCT_QUERY_KEY,
  REACT_QUERY_GET_PRODUCT_DETAIL_QUERY_KEY,
} from '../constants';

export const useEditProduct = (productIdOrSlug) => {
  const mutation = useMutation((data) => productEditUseCase.editProduct(productIdOrSlug, data));
  return mutation;
};

export const useEditProductDetail = (productIdOrSlug, productDetailId) => {
  const mutation = useMutation((data) =>
    productEditUseCase.editProductDetail(productIdOrSlug, productDetailId, data)
  );
  return mutation;
};

export const useUpdateProductDetailImageOrdering = (productIdOrSlug, productDetailId) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) =>
      productEditUseCase.updateProductDetailImageOrdering(productIdOrSlug, productDetailId, data),
    onSuccess: () => {
      // Invalidate product detail cache to refetch with updated image ordering
      if (productIdOrSlug) {
        queryClient.invalidateQueries({
          queryKey: [REACT_QUERY_GET_PRODUCT_QUERY_KEY, productIdOrSlug],
        });
      }

      if (productDetailId) {
        queryClient.invalidateQueries({
          queryKey: [REACT_QUERY_GET_PRODUCT_DETAIL_QUERY_KEY, productDetailId],
        });
      }
    },
  });

  return mutation;
};
